import { Modal } from '@simplywallst/ui-core';

import { AddHoldingsMobile } from '../AddHoldings';
import { EditHoldings } from '../EditHoldings';
import type { ManualPortfolioState } from '../CreateManualPortfolio';

import { usePortfolio } from '@/hooks/usePortfolio';
import type { Portfolio } from '@/hooks/usePortfolio';

import type { PortfolioToUpdate } from '../../context/ManualPortfolioContext';

import { Overlay } from './styled';

interface Props {
  initialData?: PortfolioToUpdate;
  portfolioId: Portfolio['id'] | null;
  setPortfolioId: (id: string) => void;
  onClose: () => void;
  manualPortfolioState: ManualPortfolioState;
  setManualPortfolioState: (state: ManualPortfolioState) => void;
}

export const HoldingsModal = ({
  initialData,
  portfolioId,
  onClose,
  manualPortfolioState,
  setManualPortfolioState,
  setPortfolioId,
}: Props) => {
  const { data: portfolio } = usePortfolio({
    id: portfolioId ?? '',
  });
  return (
    <Modal isNaked onClose={onClose}>
      {manualPortfolioState === 'add' ? (
        <AddHoldingsMobile
          portfolio={portfolio}
          onClose={onClose}
          setManualPortfolioState={setManualPortfolioState}
          setPortfolioId={setPortfolioId}
        />
      ) : manualPortfolioState === 'edit' && portfolio ? (
        <Overlay templateRows="max-content 1fr" row="2" gap="24px">
          <EditHoldings
            initialData={initialData}
            onClose={onClose}
            portfolio={portfolio}
            setManualPortfolioState={setManualPortfolioState}
          />
        </Overlay>
      ) : null}
    </Modal>
  );
};
